export enum ContractStatusEnum {
  DEFAULT,
  STORE_KEEPING,
  REQUEST_PICKUP,
  ACCEPTED_PICKUP,
  IN_WAREHOUSE,
  REQUEST_DELIVERY,
  ACCEPTED_DELIVERY,
  IN_DELIVERY,
  INSPECTION_COMPLETED,
  COMPLETED,
}
